module.exports = __webpack_public_path__ + "img/3.871b16b4.png";